export function debouncer(delay: number) {
	const state = {
		timer: null as null | number,
		// startedAt: null as null | number,
	};
	
	return function(handler: () => void) {
		if (state.timer) {
			// const endedAt = performance.now();
			// console.log(state.startedAt && endedAt - state.startedAt);
			window.clearTimeout(state.timer);
		}
		
		// state.startedAt = performance.now();
		state.timer = window.setTimeout(handler, delay);
	};
}
